import isNull from 'lodash/isNull'
import Swiper, { Autoplay} from 'swiper'
Swiper.use([Autoplay])

export default class Tooltip {
    constructor() {
        this.cacheDom()
        this.init()
    }

    cacheDom() {
        this.swiper = []
        this.items = document.querySelectorAll('.swiper-container')
    }

    init() {
        if (!isNull(this.items)) {
            Array.prototype.forEach.call(this.items, (el, i) => {
                this.swiper[i] = new Swiper(el, {
                    direction: 'vertical',
                    slidesPerView: 1,
                    height: 60,
                    centeredSlides: true,
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: false,
                    }
                })
            })
        }
    }
}